import { createSelector } from "reselect";

export const getData = state => state.app.ums;

export const getPreferences = createSelector(
  getData,
  ({ preferences }) => preferences
);
export const getCustomer = createSelector(getData, ({ customer }) => customer);
